import React, { useState, useEffect } from 'react';

import { Grid, Box } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Description } from '@mui/icons-material';

import Typography from '@mui/material/Typography';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

import { url, urlLive } from "../../constant";

function RequestList2() {

    const [requests, setRequests] = useState([]);  // Stores the requests data
    const [searchQuery, setSearchQuery] = useState('');  // State for the search query
    const [filteredRequests, setFilteredRequests] = useState([]); // Stores the filtered requests

    // Fetch requests when the component mounts
    useEffect(() => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        fetch(`${url}auth/get-requests`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.message === "Requests retrieved successfully.") {
                    setRequests(result.data);  // Set the fetched requests data
                    setFilteredRequests(result.data); // Initially, display all requests
                }
            })
            .catch((error) => console.error("Error fetching requests:", error));
    }, []);  // Empty dependency array to run only once when the component mounts



    // FullRemoteLabel Component with concise text and improved styling
    const FullRemoteLabel = ({ fullRemote }) => {
        let label;
        let labelStyle;

        switch (fullRemote) {
            case 1:
                label = "Remote";  // Short, professional text
                labelStyle = { color: '#28a745', fontWeight: 'bold' };  // Green for remote
                break;
            case 0:
                label = "On-site";  // Short, professional text
                labelStyle = { color: '#dc3545', fontWeight: 'bold' };  // Red for on-site
                break;
            default:
                label = "Unknown";  // Fallback text
                labelStyle = { color: '#6c757d', fontWeight: 'normal' };  // Gray for unknown status
        }

        return <span style={labelStyle}>{label}</span>;
    };

    // Handle the search input change
    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        if (query === "") {
            // If the search query is empty, reset to show all requests
            setFilteredRequests(requests);
        } else {
            // Filter requests based on the query
            const filtered = requests.filter((request) => {
                const titleMatches = request.Title && request.Title.toLowerCase().includes(query);
                const descriptionMatches = request.Description && request.Description.toLowerCase().includes(query);

                return titleMatches || descriptionMatches;
            });

            setFilteredRequests(filtered);  // Update the filtered requests
        }
        
    };

    return (
        <DashboardLayout >
            <DashboardNavbar />
            <MDBox py={2}>
                <MDBox px={2} mx={2} mt={2}>
                    <Grid container spacing={3}>

                        <Grid item xs={12} >
                            <MDBox mb={-2}>
                                <Grid

                                    spacing={2}
                                    sx={{
                                        backgroundColor: 'lightgray', // Change to your desired background color
                                        padding: 2,  // Optional: to add some padding inside the grid container
                                        borderRadius: 1,  // Optional: to give rounded corners to the container
                                        '& .MuiGrid-item': { // Target all Grid items inside this container
                                            paddingLeft: '2px', // Negative padding on all items
                                            paddingTop: '2px'
                                        },

                                    }}
                                >
                                    <Grid item xs={12} md={6} lg={4}>
                                        <MDTypography variant="h4" fontWeight="regular" color="text">
                                            {/* Requesta */}
                                            {/* Richieste */}
                                            Requests
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                            </MDBox>
                        </Grid>

                        <Grid xs={12} pl={3} mt={4}>
                            <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'space-between'}>
                                <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-start'}>
                                    {/* <h3>Elenco Annunci</h3> */}
                                    <h3>List of Announcements</h3>

                                </Stack>
                                <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                                    <div>
                                        <Button variant="contained">
                                            {/* <a style={{color: 'white'}}>CREA NUOVO ANNUNCIO</a> */}
                                            <a style={{ color: 'white' }}>CREATE NEW AD</a>
                                        </Button>
                                    </div>
                                </Stack>

                            </Stack>
                        </Grid>

                        <Grid xs={12} pl={3} mt={4}>
                            <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'space-between'}>

                                <Stack sx={{ display: 'flex', alignItems: 'center', width: '100%' }} spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                                    <Paper
                                        component="form"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                                    >
                                        <IconButton sx={{ p: '10px' }} aria-label="menu">
                                            <SearchIcon />
                                        </IconButton>
                                        <InputBase
                                            sx={{ ml: 1, flex: 1, width: '100%' }}
                                            // placeholder="Ricerca"
                                            placeholder="Research"
                                            inputProps={{ 'aria-label': 'search' }}
                                            value={searchQuery}  // Set the search query value
                                            onChange={handleSearchChange}  // Handle the search input change
                                        />

                                    </Paper>
                                </Stack>

                            </Stack>
                        </Grid>

                        <Grid xs={12} pl={3} mt={4}>
                            <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'space-between'}>
                                <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-start'}>
                                    <Button sx={{ backgroundColor: '#9d9d9d' }} variant="contained">
                                        {/* <a style={{color:'white'}}>Propane</a> */}
                                        {/* <a style={{color:'white'}}>Offerta</a> */}
                                        <a style={{ color: 'white' }}>Offer</a>
                                    </Button>
                                    <Button sx={{ backgroundColor: '#9d9d9d' }} variant="contained">
                                        {/* <a style={{color:'white'}}>Cerca</a> */}
                                        {/* <a style={{color:'white'}}>Ricerca</a> */}
                                        <a style={{ color: 'white' }}>Research</a>
                                    </Button>

                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Switch color={'primary'} defaultChecked />}
                                            // label="Tutti gli annunci"  
                                            label="All ads"

                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Switch color={'primary'} defaultChecked />}
                                            // label="I miei annunci"
                                            label="My ads"

                                        />
                                    </FormGroup>
                                </Stack>
                                <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                                    <div>
                                        {/* <a>Filtra per</a> */}
                                        {/* <Button variant="text">Tipologia</Button> */}
                                        <a>Filter by</a>
                                        <Button variant="text">Typology</Button>
                                    </div>
                                </Stack>

                            </Stack>
                        </Grid>

                        <Grid xs={12} pl={3} mt={4}>
                            <Grid item xs={12} >

                                {
                                    filteredRequests.map((request) => (
                                        <Grid item xs={12}  >
                                            <MDBox px={3} py={2} m={1} sx={{ borderRadius: 3, background: 'white' }} mb={4}>
                                                <Grid item xs={12} >

                                                    <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                                                        <CheckCircleIcon sx={{ color: 'green' }} />
                                                        {/* <Button variant="text">Dettaglio</Button> */}
                                                        <Button variant="text">Detail</Button>
                                                    </Stack>

                                                </Grid>
                                                <Grid item xs={12} >

                                                    <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-start'}>

                                                        <Button sx={{ background: '#04054C' }} size={"small"} variant="contained">
                                                            <a style={{ color: 'white' }}>Propane</a>
                                                        </Button>
                                                        <Button sx={{ background: '#4A60AE' }} size={"small"} variant="contained">
                                                            <a style={{ color: 'white' }}>T & M</a>
                                                        </Button>
                                                    </Stack>

                                                </Grid>
                                                <Grid item xs={12} >

                                                    <Stack mt={2} spacing={2} direction="column" alignItems={'flex-start'} justifyContent={'flex-start'}>
                                                        <h3 >{request.Title}</h3>
                                                    </Stack>

                                                    <Stack spacing={2} direction="column" alignItems={'flex-start'} justifyContent={'flex-start'}>
                                                        <Typography variant="body2" gutterBottom>
                                                            {request.Description}
                                                        </Typography>
                                                    </Stack>

                                                    <Stack mt={2} spacing={2} direction="row" alignItems={'flex-start'} justifyContent={'flex-start'}>
                                                        <Typography sx={{ fontWeight: 'bold', color: '#9d9d9d' }} variant="body2" gutterBottom >Pubblicato il: {request.PublishDate}</Typography>
                                                        {/* <Typography sx={{fontWeight: 'bold', color: '#9d9d9d'}} variant="body2" gutterBottom >Dove: Milano e/ o <FullRemoteLabel fullRemote={request.FullRemote} /> </Typography> */}
                                                        <Typography sx={{ fontWeight: 'bold', color: '#9d9d9d' }} variant="body2" gutterBottom >Where: Milano e/ o <FullRemoteLabel fullRemote={request.FullRemote} /> </Typography>
                                                    </Stack>

                                                </Grid>
                                            </MDBox>
                                        </Grid>
                                    ))
                                }

                            </Grid>
                        </Grid>

                    </Grid>
                </MDBox>

            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default RequestList2;
